import { ShieldAlert } from "lucide-react";

// Import bypass flags - keep in sync with ProtectedRoute and AdminLayout
const DEV_BYPASS_AUTH = false;
const DEV_BYPASS_ADMIN = false;

const DevBypassIndicator = () => {
  const authBypass = DEV_BYPASS_AUTH;
  const adminBypass = DEV_BYPASS_ADMIN;

  // Only show in Lovable preview, never on the real domain
  const isLovablePreview = window.location.hostname.includes('lovable');
  if (!isLovablePreview) return null;
  if (!authBypass && !adminBypass) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] bg-destructive/10 border-2 border-destructive/40 rounded-lg px-4 py-3 shadow-lg text-xs font-mono max-w-xs backdrop-blur-sm animate-pulse-slow">
      <div className="flex items-center gap-2 font-bold text-destructive mb-1">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        DEV BYPASS ACTIEF
      </div>
      <div className="text-destructive/80 space-y-0.5">
        {authBypass && <div>🔓 Dashboard auth: <span className="font-bold">OVERGESLAGEN</span></div>}
        {adminBypass && <div>🔓 Admin auth: <span className="font-bold">OVERGESLAGEN</span></div>}
      </div>
      <div className="mt-1.5 text-[10px] text-destructive/60">
        Zet op false vóór publicatie!
      </div>
    </div>
  );
};

export default DevBypassIndicator;
